export default __webpack_public_path__ + "static/media/CNo.89-3.746b119f.jpg";